/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { Button } from "../../../ui/button";
import { IUserFileMgmt } from "../../../../store/api/admin/types";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { setConfirmDialog } from "../../../../store/helpers/helperReducers";
import { setSelectedUserFileMgmt } from "../../../../store/api/admin/reducers";
import { useStoreDispatch } from "../../../../store/hooks";
import { Icon } from "../../../Shared/Icon";

interface IActionItemProps {
    rowData: IUserFileMgmt,
}

const ExternalActionItems: React.FC<IActionItemProps> = ({ rowData }) => {
    const dispatch = useStoreDispatch();
    // Commenting out this edit option now because of NIMS-822
    // const editHandler = () => {
    //     dispatch(setIsAddNewUserFileMgmt(false))
    //     dispatch(setSelectedUserFileMgmt(rowData));
    //     dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.USERFILEMGMT));

    // };
    const deleteUserFileMgmtHandler = () => {
        dispatch(setSelectedUserFileMgmt(rowData));
        dispatch(setConfirmDialog(DIALOGOPENFOR.DELETEEXTERNALUSER));
    }
    return (
        <div className="flex items-center">
            {/* <Button variant="ghost" size="icon" className="h-8 w-8" title="Edit" onClick={editHandler}>
                <Pencil className="h-4 w-4 text-primary" />
            </Button> */}
            <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 bg-transparent text-foreground hover:bg-accent hover:text-foreground" aria-label="Delete" onClick={deleteUserFileMgmtHandler}>
                <Icon name="delete" size={20} />
            </Button>
        </div>
    )
}
export default ExternalActionItems;